import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import hash from 'object-hash';
import memoize from 'lodash/memoize';

import TemplateAPI from '../data/iframe-template-api';

const createCacheBuster = memoize((feed) => hash(feed));

const styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    background: '#dff5fd',
    padding: '6px',
    margin: '6px 6px 0px 0px',
    borderRadius: '6px',
    flexDirection: 'column',
  },
  previewSize: {
    margin: '6px',
    color: '#00aced',
    fontSize: '18px',
    fontStyle: 'italic',
  },
};

class TemplateFeedPreview extends Component {
  componentDidMount() {
    this.templateAPI.updateFeed(this.props.feed);
  }

  componentDidUpdate() {
    if (this.updateFeedTimeoutId) {
      clearTimeout(this.updateFeedTimeoutId);
    }
    // This is a hack around the fact the templates need to fully load their core js libary before
    // accepting feed data. The timeout allows the core template lib to start, however the issue of templates
    // not updating might still happen because of network speed of the user. If we are finding we need to increase this timeout
    // delay we should just fix this at the template library level. For the current scope of this project this is an
    // acceptable hack.
    this.updateFeedTimeoutId = setTimeout(() => {
      this.templateAPI.updateFeed(this.props.feed);
    }, 2000);
  }

  componentWillUnmount() {
    this.templateAPI.destroy();
    if (this.updateFeedTimeoutId) {
      clearTimeout(this.updateFeedTimeoutId);
      this.updateFeedTimeoutId = null;
    }
  }

  render() {
    const { classes } = this.props;
    // A cachebuster is need to force the iframe page to reload when there is a new feed to display.
    // To improve performance the hash result is memoized based on the feed object.
    const cacheBuster = createCacheBuster(this.props.feed);
    const { PUBLIC_URL } = process.env;
    const src = `${PUBLIC_URL}/templates/${this.props.templateName}/index-${this.props.width}x${this.props.height}.html?provider=preview&cache=${cacheBuster}`;
    return (
      <div className={classes.root}>
        <div className={classes.previewSize}>
          {this.props.width}x{this.props.height}
        </div>
        <iframe
          title={`${this.props.templateName} ${this.props.width}x${this.props.height}`}
          ref={(iframe) => { this.templateAPI = new TemplateAPI(iframe); }}
          src={src}
          height={`${this.props.height + 2}`}
          width={`${this.props.width + 2}`}
          frameBorder="0"
        />
      </div>
    );
  }
}

TemplateFeedPreview.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  templateName: PropTypes.string.isRequired,
  feed: PropTypes.arrayOf(PropTypes.object),
  classes: PropTypes.object,
};

export default withStyles(styles)(TemplateFeedPreview);



// WEBPACK FOOTER //
// ./src/templates/display/components/DisplayFeedTemplate.jsx